import React from 'react'
import {Route, IndexRoute, IndexRedirect} from 'react-router'

import AnalyticsView from 'views/AnalyticsView'
import AnalyticsViewMenu from 'views/AnalyticsView/Menu'
import DashboardView from 'views/DashboardView'
import TrafficInsightView from 'views/TrafficInsightView'
import OrdersOverviewView from 'views/OrdersOverviewView'
import OrdersOverviewViewMenu from 'views/OrdersOverviewView/crossmenu'
import CostsView from 'views/CostsView'
import CostsViewMenu from 'views/CostsView/crossmenu'
import ReportsView from 'views/ReportsView'
import ReportView, {ReportViewMenu} from 'views/ReportView'
import {getReport} from 'redux/modules/reports/selectors'

export default (store, trackRoute) => {
  return (
    <Route path='cross-site' title='Cross Site'>
      <Route
        path='dashboard'
        component={DashboardView}
        crossSiteMode
        disableDatePicker
        onEnter={trackRoute('cross-site/dashboard')}
      />
      <Route
        path='traffic'
        title='Traffic Trends'
        component={TrafficInsightView}
        crossSiteMode
        disableDatePicker
        onEnter={trackRoute('cross-site/traffic')}
      />
      <Route path='conversions' title='Conversions'>
        <Route
          path='conversion-count'
          metric='conversion_count'
          title='Conversion Count'
          crossSiteMode
          disableDatePicker
          components={{main: OrdersOverviewView, menu: OrdersOverviewViewMenu}}
          onEnter={trackRoute('cross-site/conversion-count')}
        />
        <Route
          path='conversion-amount'
          metric='conversion_amount'
          title='Revenue'
          crossSiteMode
          disableDatePicker
          components={{main: OrdersOverviewView, menu: OrdersOverviewViewMenu}}
          onEnter={trackRoute('cross-site/conversion-value')}
        />
        <IndexRedirect to='/cross-site/conversions/conversion-count' />
      </Route>
      <Route path='costs-overview' title='Costs Overview'>
        <Route
          path='cost-per-visit'
          metric='cost_per_visit'
          crossSiteMode
          disableDatePicker
          components={{menu: CostsViewMenu, main: CostsView}}
          onEnter={trackRoute('cross-site/costs-overview_per-visit')}
        />
        <Route
          path='cost-per-conversion'
          metric='cost_per_conversion'
          crossSiteMode
          disableDatePicker
          components={{menu: CostsViewMenu, main: CostsView}}
          onEnter={trackRoute('cross-site/costs-overview_per-conversion')}
        />
        <IndexRedirect to='/cross-site/costs-overview/cost-per-visit' />
      </Route>
      <Route path='analytics' title='Analytics Explorer'>
        <Route path='reports' title='Reports'>
          <IndexRoute
            components={{main: ReportsView, menu: AnalyticsViewMenu}}
            crossSiteMode
            onEnter={trackRoute('reports')}
          />
          <Route
            path=':reportId'
            components={{main: ReportView, menu: ReportViewMenu}}
            crossSiteMode
            title={({reportId}) => {
              const report = getReport(store.getState(), reportId)

              return report ? report.name : '...'
            }}
            withBreadcrumbs
            disableDatePicker
            onEnter={trackRoute('report')}
          />
        </Route>
        <IndexRoute
          title='Analytics Explorer'
          components={{main: AnalyticsView, menu: AnalyticsViewMenu}}
          onEnter={trackRoute('cross-site/analytics-explorer')}
          showReportButton
          crossSiteMode
        />
      </Route>
      <IndexRedirect to='/cross-site/analytics' />
    </Route>
  )
}



// WEBPACK FOOTER //
// ./client/routes/crossite.js